<div class="opening-times__days">
  @for (day of days(); let dayIndex = $index; track dayIndex) {
    <span
      matTooltip="Wurde bereits verwendet"
      [matTooltipDisabled]="!isDayDisabledFn()(dayIndex)">
      <button
        mat-icon-button
        type="button"
        (click)="onDayClick(dayIndex)"
        [disabled]="isDayDisabledFn()(dayIndex)"
        [attr.aria-label]="day.token"
        [ngClass]="getStatusClass(dayIndex)">
        <span class="mat-title-medium opening-times__day-icon">
          {{ day.defaultText | translate : day.token : day.scope | appSlice : 0 : 1 | uppercase }}
        </span>
      </button>
    </span>
  }
</div>
